import React from 'react';
import Icon from '@gumtree/ui-library/src/icon/icon';

import { StyledNotificationBox, StyledContent } from './notification-box.style';

export function NotificationBox({ message, iconType }: NotificationBoxProps) {
    return (
        <StyledNotificationBox>
            <Icon type={iconType} />
            <StyledContent>{message}</StyledContent>
        </StyledNotificationBox>
    );
}

interface NotificationBoxProps {
    message: string;
    iconType: string;
}
